module.exports = __webpack_public_path__ + "img/curso-presentacion-persona.8b3a55db.png";